'use client';

import { useQuery } from '@tanstack/react-query';
import { getRouletteConfig, type RouletteConfig } from '@/lib/api/roulette';

/** Конфиг коробки-рулетки. Ключ общий: главная и помощник заказа делят кэш. */
export function useRouletteConfig() {
  return useQuery({
    queryKey: ['roulette-config'],
    queryFn: getRouletteConfig,
    staleTime: 60000,
  });
}

/**
 * Коробку показываем, только если она включена, в ней есть роллы и у спина есть цена.
 * Сужаем до включённого конфига: в ветке «нет» загруженный, но выключенный конфиг
 * остаётся RouletteConfig, а не схлопывается в undefined.
 */
export function isRouletteOffered(
  config: RouletteConfig | undefined
): config is RouletteConfig & { is_active: true } {
  return (
    config?.is_active === true &&
    Array.isArray(config.products) &&
    config.products.length > 0 &&
    Number.isFinite(Number(config.price)) &&
    Number(config.price) > 0
  );
}
